"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewField = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var spinner_1 = require("../../components/spinner/spinner");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_state_1 = require("../../state/page.state");
var classnames_1 = require("../../util/classnames");
var collection_view_style_1 = require("./collection.view.style");
var field_view_builder_1 = require("./fields/field.view.builder");
var CollectionEditViewField = /** @class */ (function () {
    function CollectionEditViewField() {
    }
    CollectionEditViewField.view = function (ctrl, collection, schema) {
        var _a;
        var id = "i-".concat(collection.instanceId, "-").concat(schema.id);
        var field = collection.getField(schema.id);
        var fieldView = field_view_builder_1.CollectionFieldViewBuilder.getFieldView(field);
        var hasValue = field.hasValue();
        var hasDetail = hasValue && fieldView.hasDetail && fieldView.hasDetail(field);
        var showDetail = ctrl.isFieldDetailShown.get(id);
        var hasUpload = fieldView.canUpload && fieldView.canUpload(field) && ctrl.isEditing;
        var imageTool = null;
        if (fieldView.canUpload && fieldView.canUpload(field)) {
            imageTool = field;
        }
        var hasGeocoding = fieldView.canGeocoding && fieldView.canGeocoding(field);
        var hasFile = fieldView.hasFile && fieldView.hasFile(field);
        var fileToolField = null;
        if (hasFile) {
            fileToolField = field;
        }
        var isLoading = (core_shared_1.CollectionModelFieldFileTool.isFileToolField(field) || core_shared_1.CollectionModelFieldImage.isImageField(field)) && ctrl.isUploading && ctrl.fieldsInLoadingState.indexOf(field.id) > -1;
        var hasClear = false;
        var fieldValue;
        var userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) || services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        var userCanEditField = userIsAdmin || !field.schema.adminOnly;
        if (ctrl.isEditing && userCanEditField) {
            fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, fieldView.viewEdit(field, ctrl));
            hasClear = fieldView.hasClear == null ? hasValue : fieldView.hasClear(field);
            // if the field is CollectionModelFieldVector and the provider is collection, but it's not exists anymore
            // the field text is 'Unknown' but we don't have value, so we don't show the clearButton
            // we fix that here
            if ((core_shared_1.CollectionModelFieldVector.isVectorField(field) || core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) &&
                typeof fieldView.viewEdit(field, ctrl) !== 'string' &&
                fieldView.viewEdit(field, ctrl).text === (0, i18n_1.Translate)(i18n_1.T.UNKNOWN)) {
                hasClear = true;
            }
        }
        else if (hasValue) {
            var inlineText = fieldView.viewInline(field, ctrl);
            if (typeof inlineText === 'string') {
                var children = [inlineText];
                if (
                // We have the correct token
                services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG)
                    // And the field is one of the two list types which can have colors
                    && (core_shared_1.CollectionModelFieldSelectList.isSelectListField(field) || core_shared_1.CollectionModelFieldNestedList.isNestedListField(field))
                    // And this instance is the one that is marked as the color field
                    && field.collection.schema.metadata.mapColorFieldId === field.schema.id) {
                    if (field.color) {
                        children.push((0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.colorIndicator, style: { backgroundColor: field.color } }));
                    }
                }
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value, title: inlineText }, children);
            }
            else {
                fieldValue = (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.value }, inlineText);
            }
        }
        var title = schema.displayName;
        return (0, mithril_1.m)('div', {
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.field.container, (_a = {},
                _a[collection_view_style_1.CSS.isEmpty] = !hasValue,
                _a)),
            id: id,
            onclick: function (e) {
                var handleClickAway = function () {
                    page_state_1.CurrentState.setInspectedFieldId(null);
                    services_1.Services.FocusAway.drop(e.target, handleClickAway);
                };
                page_state_1.CurrentState.setInspectedFieldId(field.id);
                services_1.Services.FocusAway.from(e.target, handleClickAway);
            }
        }, [
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.summary }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.title, title: title }, title),
                fieldValue,
                isLoading ? CollectionEditViewField.viewLoadingSpinner(ctrl, field) : null,
                hasUpload ? CollectionEditViewField.viewFieldUploadButton(ctrl, imageTool) : null,
                hasFile ? CollectionEditViewField.viewFileDownloadButton(ctrl, fileToolField) : null,
                (hasClear && hasFile) ? CollectionEditViewField.viewFieldClearModalButton(ctrl, field) : null,
                (hasClear && !hasFile) ? CollectionEditViewField.viewFieldClearButton(ctrl, field) : null,
                hasDetail ? CollectionEditViewField.viewFieldDetailButton(ctrl, id) : null,
                hasGeocoding ? CollectionEditViewField.viewFieldGeocodingButton(ctrl, field) : null,
                hasGeocoding && !ctrl.clearErrorDisabled(field) ? CollectionEditViewField.viewFieldClearErrorButton(ctrl, field) : null
            ]),
            showDetail ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.detail }, fieldView.viewDetail(field)) : null
        ]);
    };
    CollectionEditViewField.viewFieldClearErrorButton = function (ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: function () { return ctrl.clearError(field); },
            disabled: ctrl.clearErrorDisabled(field)
        });
    };
    CollectionEditViewField.viewFieldClearButton = function (ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: function () { return ctrl.clearField(field); }
        });
    };
    CollectionEditViewField.viewFieldClearModalButton = function (ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            onclick: function () { return ctrl.clearModalField(field); }
        });
    };
    CollectionEditViewField.viewFieldDetailButton = function (ctrl, fieldInstanceId) {
        var icon = icons_1.MaterialIcon.INFO_FILLED;
        if (ctrl.isFieldDetailShown.get(fieldInstanceId)) {
            icon = icons_1.MaterialIcon.INFO;
        }
        return image_button_1.ImageButton.view(icon, {
            onclick: function () { return ctrl.toggleFieldDetail(fieldInstanceId); }
        });
    };
    CollectionEditViewField.viewFieldGeocodingButton = function (ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.LOCATION, {
            onclick: function () { return ctrl.fillAddress(field); },
            disabled: ctrl.fillAddressDisabled(field),
            title: ctrl.geocodingButtonTitle(field)
        });
    };
    CollectionEditViewField.viewLoadingSpinner = function (ctrl, field) {
        return spinner_1.Spinner.view();
    };
    CollectionEditViewField.viewFileDownloadButton = function (ctrl, field) {
        return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
            onclick: function (e) { return ctrl.fileDownload(field); }
        });
    };
    CollectionEditViewField.viewFieldUploadButton = function (ctrl, field) {
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.field.isImageUpload }, (0, mithril_1.m)('form', [
            (0, mithril_1.m)('input', { className: 'c--Image--fileupload', style: 'display:none;', type: 'file', accept: 'image/jpeg', id: field.id, onchange: function (e) { return ctrl.onImage(e, field); } }, ''),
            (0, mithril_1.m)('div', {
                id: "image-upload-".concat(field.id),
                style: 'border:none',
                className: collection_view_style_1.CSS.container,
                onclick: function (e) { return ctrl.openImageDialog(e, field); }
            }, image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_UPLOAD))
        ]));
    };
    return CollectionEditViewField;
}());
exports.CollectionEditViewField = CollectionEditViewField;
//# sourceMappingURL=collection.view.field.js.map